var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 33,
    viewBox: "0 0 31 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.1637 26.7912C26.6067 25.2555 26.4714 18.6636 26.4688 18.4972V14.0748C26.4688 9.8185 23.7483 6.1585 19.8823 4.60012C19.874 2.41182 18.0098 0.634033 15.7192 0.634033C13.4285 0.634033 11.5643 2.41192 11.5559 4.60001C7.69018 6.1584 4.96962 9.81839 4.96962 14.0747V18.4971C4.9671 18.6635 4.83168 25.2554 1.27455 26.7911C0.869337 26.9661 0.64663 27.3878 0.740318 27.8034C0.833896 28.2191 1.21833 28.5159 1.66303 28.5159H10.6807C10.8656 29.4881 11.3464 30.3926 12.0819 31.1252C13.0587 32.0982 14.3504 32.634 15.719 32.634C17.0877 32.634 18.3795 32.0982 19.3561 31.1252C20.0917 30.3926 20.5726 29.488 20.7573 28.5159H29.775C30.2197 28.5159 30.6041 28.2191 30.6977 27.8034C30.7915 27.3878 30.5689 26.9662 30.1637 26.7912ZM25.4781 23.6333C25.852 24.7171 26.3815 25.8056 27.1323 26.7113H4.30593C5.05663 25.8057 5.58611 24.7173 5.96004 23.6333H25.4781ZM17.9055 4.01167C17.6314 3.10437 16.7553 2.43875 15.7192 2.43875C14.6831 2.43875 13.807 3.10442 13.5328 4.01167C14.239 3.87159 14.9703 3.79781 15.7192 3.79781C16.4681 3.79781 17.1993 3.87164 17.9055 4.01167ZM6.85732 18.5027V14.0747C6.85732 9.40312 10.8327 5.60253 15.7192 5.60253C20.6056 5.60253 24.581 9.40312 24.581 14.0747V18.51C24.5823 18.6458 24.6044 20.0723 24.9804 21.8285H6.45768C6.83397 20.0707 6.85617 18.6416 6.85732 18.5027ZM12.6176 28.5159C13.0212 29.8364 14.2785 30.8295 15.7192 30.8295C17.1599 30.8295 18.417 29.8364 18.8206 28.5159H12.6176Z",
    fill: "#BFC5D2"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.71c1edb8.svg";
export { ForwardRef as ReactComponent };